import React from 'react';

const OurPartners = () => {
  // Partner data
  const partners = [
    {
      id: 1,
      name: 'CRAFT3',
      logo: '/craft-3.png',
      url: 'https://www.craft3.org/',
      description: 'Nonprofit Community Development Financial Institution (CDFI)',
      category: 'Lender'
    },
    {
      id: 2,
      name: 'TruDBooks',
      logo: '/TruDBooks-logo.png',
      url: 'https://trudbooks.org/',
      description: 'Accounting, Tax and Assurance services',
      category: 'Service Provider'
    },
    {
      id: 3,
      name: 'HalalWallet',
      logo: '/HalalWallet.png',
      url: 'https://halalwallet.us/',
      description: 'Where Muslims make financial decisions in the US',
      category: 'Partner'
    }
  ];

  return (
    <section className="py-12 bg-slate-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1a4a1a] mb-4">
          Partners Who Help You Get Funding
          </h2>
        </div>

        {/* Partners Grid */}
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-8 mx-auto">
          {partners.map((partner) => (
            <a
              key={partner.id}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white rounded-xl border border-[#1a4a1a]/10 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 overflow-hidden"
            >
              <div className="p-4 flex items-center justify-center">
                <div className="w-24 h-14 bg-slate-50 rounded-lg flex items-center justify-center border border-[#1a4a1a]/10 group-hover:border-[#1a4a1a]/20 transition-colors">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurPartners;
